import { forwardRef } from 'react';
import { TemplateEmailForNDBModal } from './TemplateEmailForNDBModal';
import { ModalDefaultProps } from 'components/Modal';

import confirmedImg from 'assets/images/modals/NDB/modal-image-email-confirmed.webp';

export const ConfirmedEmailForNDBModal = forwardRef<
  HTMLDivElement,
  ModalDefaultProps
>(({ onClose }, ref) => {
  return (
    <TemplateEmailForNDBModal
      img={confirmedImg}
      onClose={onClose}
      link="/bonuses?tab=all-offers&block=promocode"
      ref={ref}
    />
  );
});
